// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import filters from './filters'
import auth from './auth'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import VeeValidate, {
  Validator
} from 'vee-validate'
import VueCookie from 'vue-cookie'
import VueResource from 'vue-resource'
import ptBR from 'vee-validate/dist/locale/pt_BR'
import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'

Vue.use(CxltToastr, {
  position: 'top center',
  showDuration: 3000,
  timeOut: 3000
})
Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(VueCookie)

Validator.addLocale(ptBR)
Vue.use(VeeValidate, {
  locale: 'pt_BR'
})
filters.create(Vue)

Vue.mixin({
  methods: {
    showSuccess(msg) {
      this.$toast.success({
        message: msg,
        hideMethod: ''
      })
    },
    showError(msg) {
      this.$toast.error({
        message: msg,
        hideMethod: 'hinge'
      })
    },
    showInfo(msg) {
      this.$toast.info({
        message: msg,
        hideMethod: ''
      })
    },
    showWarning(msg) {
      this.$toast.warn({
        message: msg,
        hideMethod: ''
      })
    }
  }
})

/* eslint-disable no-new */
var app = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  created: function () {
    console.log('Intializing VueJS')
    axios.interceptors.request.use(function (config) {
      // Add a request interceptor
      config.headers.Authorization = `Basic ${auth.getToken()}`
      config.headers.RealmId = app.$root.currentRealm.id
      return config
    }, function (error) {
      // Do something with request error
      return Promise.reject(error)
    })
    // Add a response interceptor
    let showWarning = this.showWarning
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      if (error.response.status === 403 || error.response.status === 401) { // exibe mensagem de nao autorizado
        showWarning(error.response.data.message)
      }
      return Promise.reject(error)
    })

    this.$root.currentRealm = {
      name: 'realm',
      id: 'id'
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js